import Vue from "vue";
import VueI18n from "vue-i18n";

export const defaultLocale = "sl";

export const languages = {
  en: "en",
  sl: "sl",
};

Vue.use(VueI18n);

const messages = {
  en: {
    home: {
      welcomeMsg:
        "Helping you make <br ><strong>informed decisions with science</strong>.",
      leading:
        "BrevisVelox is <strong>neither a questionnaire nor a survey</strong>.<br /><br />BrevisVelox is a scientific research method, model, and delivery tool which helps you make decisions with highest accuracy.",
    },
    links: {
      getInTouch: "Get in touch to learn more",
    },
    reasonsWhy: {
      support: {
        title: "Support from our experts",
        text:
          "Our team of scientists & experts will help guide you through each step in order for you to receive the right information to make informed decisions.",
      },
      fast: {
        title: "Fast & efficient",
        text:
          "Unlike classical research models & surveys, our state-of-the-art research model ensures a tailor-made research can be launched and delivered with highest result accuracy in a matter of days.",
      },
      useful: {
        title: "Useful results",
        text:
          "Based on years of experience, all our results are delivered in an easy-to-understand and transparent manner, so you receive direct and unambiguous answers to your questions, so you can take the next steps without any uncertainty.",
      },
    },
    comparison: {
      title: "BrevisVelox compared to old-school outdated research",
      attribs: {
        li1: "Attribute importance",
        li2: "Price sensitivity",
        li3: "Competition analysis",
        li4: "Individual profiles",
      },
      standard: "Standard survey",
      conjoint: "Conjoint Analysis",
      brevis: "BrevisVelox",
    },
    howDoesItWork: {
      title: "How does it work?",
      text:
        "Based on the questions you need answered, we use advanced research models to formulate very specific and tailored questions, which are displayed in carefully planned order.",
    },
    unmatched: {
      title: "Unmatched accuracy",
      text:
        "Our advanced algorithms instantly identify and eliminate frivolous respondents and can guarantee survey results with unprecedented accuracy.",
    },
    decisionExamples: {
      title:
        "Just a few examples where BrevisVelox can help you make informed decisions:",
      decisions: [
        "Designing new products or modifying existing ones;",
        "Estimating the most appropriate price of a product;",
        "Estimating brand equity;",
        "Measure the relative importance of the attributes;",
        "Optimize the configuration of a product;",
        "Understand sensitivity to price;",
        "Optimize the configurations and prices of the products in a portfolio;",
        "Simulate the effect on your market share of an anticipated change in your competitor’s products or prices;",
        "Individual profiles: Obtain the individuals’ preferences and willingness-to-pay.",
      ],
    },
    consultation: {
      title: "Free consultation with our experts",
      leading:
        "Would you like to know more about how we can help you make informed decisions for your business?",
      button: "Get in touch with our experts",
    },

    process: {
      title: "The BrevisVelox process",
      step1: {
        step: "Project start",
        title: "You Tell Us What You Need To Find Out.",
        text:
          "Allready in this step our experts can help you ask the right questions based on the decisions which are infront of you.",
      },
      step2: {
        step: "Research setup",
        title:
          "Our Scientists Carefully Define The Research Model And Target Audience.",
        text:
          "This is no “one-shoe-fits-all” research method, so we carefully design the model based on your needs & target groups.",
      },
      step3: {
        step: "Doing the research",
        title: "We Carry Out The Research With Target Audience(s).",
        text:
          "With our digital platform we carry out everything: from reaching the right target group, to converting them to respondents quickly and efficiently.",
      },
      step4: {
        step: "Received results",
        title:
          "You Receive Unambiguous Results Together With All The Corresponding Data In An Easy-To-Understand Format.",
        text:
          "With our results there is no second-guessing whether the data was interpreted in the right way, we provide you with direct answers to the questions that needed answering.",
      },
    },
    industry: {
      title: "Who is it best suitable for?",
      marketing: {
        title: "Marketing & product development",
        text:
          "Analyze the impact of brand name on market shares, or the willingness to pay for products and services. Further, one can analyze preferences in impulsive or routine purchases (e.g. supermarket items) to purchases that require limited decision making (e.g. insurance policies) or extensive decision making (e.g. purchase of a car). Also, one can evaluate market potential of new products or product features.",
      },
      health: {
        title: "Healthcare & pharmaceuticals",
        text:
          "Analyze how patients and physicians value their experience and how they make trade-offs between health outcomes, side effects, waiting time, etc. Also, one can elicit preferences of certain medical treatments (e.g. medication, surgery), vaccination, and screening for different types of diseases, or to estimate QALY (quality-adjusted-life-year) health state values.",
      },
      transport: {
        title: "Transport & logistics",
        text:
          "Obtain the willingness-to-pay for travel time savings in order to forecast demand for toll roads or analyse impacts of other road pricing measures. Other applications include mode choice studies, predicting market shares for new high speed rail lines, analysing preferences in choosing freight shipping services, and forecasting the use autonomous vehicles.",
      },
      politics: {
        title: "Politics & public opinion",
        text:
          "Analyze public opinion and interaction effects with respect to specific questions and political parties. BrevisVelox can also capture preferences from undecided voters and model impact of new political parties entering the public arena.",
      },
      environment: {
        title: "Environment & ecology",
        text:
          "BrevisVelox can be used for the valuation of biodiversity in forests or the preservation of landscape and heritage. Also one can obtain the willingness-to-pay for environmentally friendly growth methods, estimate the economic value of river ecosystems and water management policies, preferences for cattle traits, or willingness to pay for renewable energy or organic food.",
      },
    },
    privacy: {
      title: "Privacy policy",
      content: {
        p0: {
          intro: "This Privacy Policy sets out the relationship between:",
          li1:
            "persons participating in survey research (hereinafter referred to as respondents);",
          li2:
            "individuals who conduct survey research within brevisvelox.com (hereinafter referred to as survey users) or any other person who has sent you a link to the survey or otherwise invited you to participate in it; and",
          li3:
            "Brevis Velox d.o.o., Podbreznik 15, 8000 Novo mesto (hereinafter Brevis Velox).",
          outro:
            "Brevis Velox owners and managers are aware of the importance of privacy protection and act in accordance with the Personal Data Protection Act (ZVOP-1) and in accordance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of individuals in the processing of personal data on the free movement of such data and on the repeal of Directive 95/46 / EC (General Data Protection Regulation). In addition, they take into account the recommendations and good practices of the codes of ethics 'ICC / ESOMAR International Code on Market and Social Research' and 'ESOMAR Guideline for Online Research' (www.esomar.org).",
        },
        p1: {
          title: "I. PRIVACY AND PERSONAL DATA OF RESPONDENTS",
          text:
            "All data that you provide as a respondent by answering survey questions are collected in an anonymous form.<br><br>In the event that there is personal data that respondents provide with prior consent to the survey editors (e.g. e-mail address), personal data and survey data are strictly separated. In the case of sending electronic survey invitations (the same applies to enabling related telephone calls or written invitations), Brevis Velox ensures the separation of the two databases and thus prevents the identification of answers. If the User demonstrates a reasonable legal basis (consent and knowledge of the respondents), they can request Brevis Velox to turn this on exceptionally at the User's request.",
          sub1: {
            title: "Acceptance of general conditions",
            text:
              "The User is obliged to comply with these General Terms and Conditions. By using the brevisvelox.com website, the User accepts these General Terms and Conditions and declares that he/she is acquainted with them and that he/she agrees with them.",
          },
          sub2: {
            title:
              "Exercising the rights of the individual concerning his or her data",
            text1:
              "You have the right to request: access to personal data, correction, deletion or restriction of processing; you also have the right to object to the processing and the right to data portability. You can apply for rights:",
            text2:
              "<li>electronic;</li><li>by mail; or.</li><li>in person.</li>",
            text3:
              "For reliable identification in exercising rights related to personal data, the controller may request additional data from you and may refuse the enforcement procedure of exercising rights only if it proves that it cannot reliably identify you.",
          },
          sub3: {
            title: "Individual / respondent rights",
            text:
              "The individual has the right to obtain confirmation from the controller of personal data whether personal data are processed in relation to him and, where this is the case, also access to them (right of access to data).<br><br>If we process personal data that is inaccurate or incomplete, the individual has the right to request that we correct inaccurate data about you without undue delay (right to rectification).<br><br>When you believe that we no longer need your personal data for the purposes for which we collected it, or if you revoke your consent to the processing of personal data and to the processing of personal data, there is no other legal basis if you object to the processing of your personal data, if you believe that personal data have been processed illegally or if personal data needs to be deleted in order to fulfil a legal obligation, you can request the deletion of personal data from us (right of deletion).<br><br>With regard to the processing of personal data, you also have the right to restrict the processing of your personal data (right to limit processing) when you dispute the accuracy of the data if the processing is illegal and you want to limit the processing instead of deleting personal data. More for the purposes of processing than you need to assert, enforce or defend legal claims, or if you have filed an objection regarding the processing of personal data.<br><br>Even if your personal data is correct and complete and we have the right to process it, you may object to the processing of this data in exceptional, justified individual cases. You can also object to receiving direct market notifications from us and request that you no longer receive them in the future (right to object).<br><br>You also have the right to receive the personal data you have provided to us in a structured, commonly used and machine-readable form and pass them on to another controller when the processing of personal data is based on your consent or contract carried out by automated means (portability).<br><br>To exercise the above rights or if you have any complaints, please contact Brevis Velox. If you believe that the processing of personal data violates the provisions in the field of personal data protection, you have the right to lodge a complaint with the Information Commissioner. The controller undertakes to process and protect the data in accordance with the Protection Act.",
          },
          sub4: {
            title: "E-mail addresses",
            text:
              "In the case of surveys published with the help of e-mail invitations, to count respondents, we also record their e-mail addresses, which are also recorded separately in the database and cannot be linked to the survey data. Only the survey editor and the persons to whom the survey author explicitly grants access to the survey have access to a separate list of IP and e-mail addresses. All such persons undertake to use this information for research purposes only, not to make it public or pass it on to third parties, and to protect their confidentiality.",
          },
        },
        p2: {
          title: "II. USE OF COLLECTED DATA",
          intro:
            "Brevis Velox owners and managers implement appropriate security measures to protect the privacy and confidentiality of data collected on servers. Only the survey editor and the persons to whom the editor explicitly grants access (this can be other users or those in charge of brevisvelox.com technical assistance) have access to the data collected by each survey. The administrators and owners of the brevisvelox.com website reserve the right to use the collected survey data, para-data, metadata, process data and other data in an anonymized form to optimize our service, for preparing analyzes of our services and for scientific research, all of which serve to improve the quality of brevisvelox.com.",
          sub1: {
            title:
              "Transmission of data to third parties podatkov tretjim osebam",
            text:
              "Brevis Velox may transfer certain personal data, in accordance with the purpose of the processing, to contractual data processors within the EU with whom it has personal data processing contracts and who processes the data on behalf of the controller and his behalf. Your data is not transferred to third countries or international organizations.",
          },
          sub2: {
            title:
              "Information on the right to revoke consent where processing is based on consent",
            text:
              "When processing is based on your consent, you can cancel it at any time. Your cancellation is valid for the future and does not affect the processing of personal data carried out before your cancellation. The processes of personal data processing based on the individual's personal consent are evident from a legal basis.",
          },
          sub3: {
            title:
              "Information on the right to complain with the supervisory authority",
            text:
              "We would also like to remind you that if you believe that the regulations governing personal data protection have been violated, you have the right to file a complaint with the Information Commissioner of the Republic of Slovenia, Dunajska cesta 22, 1000 Ljubljana. On the Website of the Information Commissioner, you can submit a report due to violations of the legislation in personal data protection via the form.",
          },
        },
        p3: {
          title: "III. MINORS",
          text:
            "Surveying of minors is regulated by national legislation. When surveying in a particular country, the User of the survey must ensure that he/she acts in accordance with the national legislation related to the survey of minors. Given the fact that full identification of minor internet users is not possible, the survey user must do everything in his power to include minors in the survey solely with the consent of their parents or legal guardians if national law requires such consent.<br><br>In Slovenia, minors up to the age of 15 must obtain parental consent before completing the questionnaire. In online surveys of children, parental permission is most often and most easily obtained by obtaining the interviewer's consent in person (e.g. visiting parents at home) or providing it in writing (e.g. through a letter brought by the child from school). Parental consent is not required to survey minors over the age of 15. However, in cases where the survey is conducted at the school, the school may require parental consent even if they are older than 15.",
        },
        p4: {
          title: "IV. FINAL PROVISIONS",
          text:
            "Brevis Velox stores the data until the purpose for which the data is collected is fulfilled. Brevis Velox collects data entered by respondents who consent to participate in the research during the research process. This means that data from respondents who have not completed each survey in full (e.g. only a few questions) are also collected and stored.<br><br>If you continue to participate in the research, it means that you understand and agree with this Statement. For any questions you have regarding this Statement or the services of brevisvelox.com, you may contact us by e-mail.",
        },
      },
    },
    terms: {
      title:
        "General terms of use of the brevisvelox.com website and limitations of liability",
      sub1: {
        title: "Definitions of terms",
        text:
          "The Owner (hereinafter: the Owner), administrator (hereinafter: Administrator) of the Website and domain brevisvelox.com is Brevis Velox d.o.o., Podbreznik 15, 8000 Novo mesto.<br><br>The site is represented by each page under the address brevisvelox.com. A Website User is any person who visits any website on the brevisvelox.com website (hereinafter: The User).<br><br>Acceptance of general conditions<br><br>The User is obliged to comply with these General Terms and Conditions. By using the brevisvelox.com website, the User accepts these General Terms and Conditions and declares that he/she is acquainted with them and that he/she agrees with them.",
      },
      sub2: {
        title: "Copyright",
        text:
          "All content posted on the Website is the exclusive property of the website owner and is copyrighted by applicable laws. In addition to text and data, the content also includes the Website's entire graphic image with all graphic elements. Any copying and publishing of any content in whole or in part in other places are prohibited unless the Owner expressly allows it in writing. If the User provides any materials to the Owner, he transfers all material copyrights to the Owner for the first time and forever and allows the use and publication of the submitted materials. In its sole discretion, the Owner may refuse registration under a title that indicates another person or is protected by intellectual property rights or is inappropriate or otherwise unacceptable.",
      },
      sub3: {
        title: "Limitation of Liability",
        text:
          "The Owner is not responsible for the accuracy, correctness, up-to-dateness of the data and information published on the Website and does not assume responsibility for the User's actions, based on the published data. The Owner is not responsible for any damage resulting from possible technical problems, service interruptions or other disturbances (for example, computer virus, power outage, mechanical failure, state authorities' decision). The Website also contains links to third party websites. The Owner assumes no responsibility for the respect of privacy and content on these websites or pages.",
      },
      sub4: {
        title: "Transitional and final provisions",
        text:
          "If any court with jurisdiction, in this case, decides that any provision of the General Terms and Conditions is invalid, then this provision will be excluded, the other provisions of the General Terms and Conditions will continue to apply and take effect.<br><br>Slovenian substantive and procedural law shall apply to the User's general conditions and relationship with the Owner and determine the jurisdiction of courts in the territory of the Republic of Slovenia.",
      },
    },
    menu: {
      process: "The Process",
      industry: "Industry applications",
      contactus: "Contact us",
    },
    footer: {
      terms: "Terms & Conditions",
      privacy: "Privacy policy",
    },
  },
  sl: {
    home: {
      welcomeMsg:
        "Sodeluj pri raziskavi in ti odloči komu podelimo dobrodelna sredstva.",
      leading:
        "Pri BrevisVelox smo se odločili, da se umaknemo od tipičnih vzorcev nagrajevanja sodelujočih pri izvrševanju raziskav in smo sredstva, ki so ponavadi namenjena za nagrade sodelujočih, namenili v dobrodelne namene. Kdo jih prejme, pa odločate vi. ",
      shortDesc:
        "Na kratko: <strong>Vsak izpolnjen vprašalnik = 1 EUR za dobrodelno organizacijo, ki jo izberete vi.</strong>",
    },

    footer: {
      terms: "Splošni pogoji",
      privacy: "Politika zasebnosti",
    },
  },
};

/* eslint-disable no-unused-vars */
const i18n = new VueI18n({
  locale: "sl", // set locale
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});
/* eslint-enable no-unused-vars */

export default i18n;
